export default {
  locationImg: "",
};
